<template>
  <fieldset class="tab tab-02">
    <div class="heading-form a-center">
      <span class="number">2/11</span>
      <p class="c-yellow">ข้อมูลส่วนตัว</p>
      <h2 class="heading-h2 c-white">อาชีพของคุณ</h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox" id="rdoOccupation">
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="vocation"
                id="student"
                class="css-checkbox"
                value="student"
                v-model="job"
              />
              <label for="student" class="css-label">นักศึกษา</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="vocation"
                id="employees"
                class="css-checkbox"
                value="employees"
                v-model="job"
              />
              <label for="employees" class="css-label">พนักงานรัฐวิสาหกิจ</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="vocation"
                id="employeesprivate"
                class="css-checkbox"
                value="employeesprivate"
                v-model="job"
              />
              <label for="employeesprivate" class="css-label">พนักงานบริษัทเอกชน</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="vocation"
                id="official"
                class="css-checkbox"
                value="official"
                v-model="job"
              />
              <label for="official" class="css-label">ข้าราชการ</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="vocation"
                id="trading"
                class="css-checkbox"
                value="trading"
                v-model="job"
              />
              <label for="trading" class="css-label">ค้าขาย / ธุรกิจส่วนตัว</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="vocation"
                id="freelance"
                class="css-checkbox"
                value="freelance"
                v-model="job"
              />
              <label for="freelance" class="css-label">อาชีพอิสระ</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="vocation"
                id="maid"
                class="css-checkbox"
                value="maid"
                v-model="job"
              />
              <label for="maid" class="css-label">แม่บ้าน</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="vocation"
                id="other"
                class="css-checkbox jobOption"
                value="etc"
                v-model="job"
              />
              <label for="other" class="css-label">
                {{
                job_etc == "" ? "อื่นๆ" : job_etc
                }}
              </label>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        id="btnPrevStepQ1"
        class="btn btn-previous previous"
        @click="prevStep('tab-02', 'tab-01')"
      >ย้อนกลับ</button>
    </div>
    <button
      type="button"
      id="btnNextStepQ3"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >ถัดไป</button>

    <a href="#popup-input-job" class="popup-input-job" style="display: none;">click me</a>
    <div id="popup-input-job" class="mfp-hide modal-input">
      <div class="modal-content">
        <div class="tb">
          <div class="tbcell v-middle">
            <div class="icw-form">
              <fieldset>
                <div>
                  <h3 class="heading-h3">อาชีพอื่นๆ</h3>
                </div>
                <div class="icw-fieldset-inner">
                  <ul class="icw-fields">
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-left">
                        <input
                          type="text"
                          id="txtEtc"
                          placeholder="โปรดระบุ"
                          v-model="job_etc"
                          maxlength="100"
                        />
                      </div>
                    </li>
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-center">
                        <button
                          type="button"
                          id="btnSubmitEtc"
                          class="btn"
                          @click="ConfJobText()"
                        >ตกลง</button>
                      </div>
                    </li>
                  </ul>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import Vue from "vue";

/* jQuery */
import jQuery from "jquery";
/* jQuery */

import { my_storage, incCurrentStep } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";
window.jQuery = window.$ = jQuery;
require("@/assets/theme/plugin/magnific-popup/jquery.magnific-popup.js");

export default {
  name: "QuestionStep1_Q2",
  props: {
    QuestionType: String
  },
  mounted() {
    this.$nextTick(() => {
      $(".popup-input-job").magnificPopup({
        type: "inline",
        midClick: true,
        removalDelay: 150,
        mainClass: "mfp-fade",
        fixedContentPos: true
      });

      $(".mfp-close").click(function() {
        Vue._data.job_etc = "";
      });

      $(".jobOption").click(function() {
        $(".popup-input-job").trigger("click");
      });
    });
  },
  data() {
    return {
      job: my_storage(this.QuestionType, "job"),
      job_etc: my_storage(this.QuestionType, "job_etc")
    };
  },
  watch: {
    job: function(n, o) {
      if (n != "etc") {
        this.job_etc = "";
      }
    }
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    beforeNextStep() {
      let pass = false;
      if (this.job != "") {
        if (this.job == "etc" && this.job_etc != "") {
          pass = true;
        } else if (this.job != "etc") {
          pass = true;
        }
      }

      if (pass) {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));

        let currentTag = this.$vnode.componentOptions.tag;
        currentTag = currentTag.replace("Q", "");
        incCurrentStep("step1", currentTag);

        this.isError = false;

        this.nextStep("tab-02", "tab-03");
      } else {
        this.isError = true;
      }
    },
    ConfJobText() {
      if (this.job_etc != "") {
        $.magnificPopup.close();
      }
    }
  },
  computed: {
    isPass() {
      let pass = false;
      if (this.job != "") {
        if (this.job == "etc" && this.job_etc != "") {
          pass = true;
        } else if (this.job != "etc") {
          pass = true;
        }
      }
      return pass;
    }
  }
};
</script>
